import { Helmet } from 'react-helmet-async';

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SwipeableViews from 'react-swipeable-views';
// @mui
import { Paper, Container, Typography, Grid, CircularProgress, Tabs, Tab, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';
import ContactInforamtion from 'src/components/Company/ContactInforamtion';
import BusinessInforamtion from 'src/components/Company/BusinessInforamtion';
import CompanyInforamtion from 'src/components/Company/CompanyInforamtion';
import BusinessDetails from 'src/components/Company/BusinessDetails';
import ForeignWorkerInformation from 'src/components/Company/ForeignWorkerInformation';
import { tabsClasses } from '@mui/material/Tabs';
import { GetCompany } from 'src/components/services/httpServices';
import EditCompany from 'src/components/Company/EditCompany';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CompanyEditPage(props) {
  let { id } = useParams();

  const [company, setCompany] = useState({});

  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');

  const fetchCompany = async (event) => {
    const company = await GetCompany(id);
    setCompany(company);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);
  const SaveCompany = async (event) => {};

  const handleClose = () => {
    setOpen(false);
  };

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  //console.log('company', company);
  return (
    <>
      <Helmet>
        <title> Employers | Immigration System </title>
      </Helmet>
      <Container>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="primary tabs example"
              variant="scrollable"
              scrollButtons
              sx={{
                [`& .${tabsClasses.scrollButtons}`]: {
                  '&.Mui-disabled': { opacity: 0.3 },
                },
              }}
            >
              <Tab label="Edit Employer" {...a11yProps(0)} />
              <Tab label="Contact Information" {...a11yProps(1)} />
              <Tab label="Business Information" {...a11yProps(2)} />
              <Tab label="Company Information" {...a11yProps(3)} />
              <Tab label="Business Details" {...a11yProps(4)} />
              <Tab label="Foreign Worker Information" {...a11yProps(5)} />
            </Tabs>

            <SwipeableViews axis="x-reverse" index={value} onChangeIndex={handleChangeIndex}>
              <TabPanel value={value} index={0}>
                <EditCompany
                  id={id}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <ContactInforamtion
                  company={company}
                  companyContactInformations={company.companyContactInformations}
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
                {/* <TestPage /> */}
              </TabPanel>
              <TabPanel value={value} index={2}>
                <BusinessInforamtion
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <CompanyInforamtion
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <BusinessDetails
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <ForeignWorkerInformation
                  setMessage={props.setMessage}
                  setLoading={props.setLoading}
                  setSaved={props.setSaved}
                  setOpen={props.setOpen}
                />
              </TabPanel>
            </SwipeableViews>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
